import createReactClass from 'create-react-class';
('use strict');

// Import Libraries
import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
// Import JS Modules
import GenericPaginatedUploadMixin from './loader-mixins/generic-paginated-upload-mixin';
import UploadAnalytics from './upload-analytics';
import { builderDispatch, PrismUI, WebUI } from '../_utils/ui';
import FileClearingMixin from './loader-mixins/file-clearing-mixin';
import FileSelectorMixin from './loader-mixins/file-selector-mixin';
import UploadButton from './utils/upload-button';
import AlbumSelector from './album-selector';
import CustomText from './custom-text';
import ImageUploadFileValidator from '../_utils/image-upload-file-validator';
import AnalyticsHandler from '../_libs/analytics/checkout-google-analytics';
import sendToGoogleAnalytics from '../_libs/analytics/builder-send-to-google-analytics';
import { db, handleDexieError } from '../_utils/db/db';
import { uploadUrl } from '../_prism-builder/desktop/lib/add-photos-interface';
import { compressImage } from '../_utils/db/image-manip-helpers';
import { convertHEICIfNeeded } from '../_prism-builder/components';
import { usePrismItemStore } from 'stores/usePrismItemStore';
import * as pdfjsLib from 'pdfjs-dist';
import { v4 as uuidv4 } from 'uuid';
import readFileAsArrayBuffer from '../_utils/readFileAsArrayBuffer';
import { sessionTracker } from '../_prism-builder/utils/session-tracker';
import { ACCEPTED_FORMATS_NOTE } from './accepted-formats-note';

const LocalFileImportIndexedDB = createReactClass({
  mixins: [GenericPaginatedUploadMixin, FileSelectorMixin, FileClearingMixin],
  displayName: 'Local file import native',

  getInitialState() {
    const { App } = window;
    this.files = this.files || [];

    return {
      loggedIn: App && App.order.logged_in(),
    };
  },
  componentDidMount() {
    this.builderDispatchToken = builderDispatch.register((payload) => {
      if (payload.type === WebUI.LOGIN) {
        this.setState({
          loggedIn: true,
        });
      }
    });
    const component = ReactDOM.findDOMNode(this);
    component.addEventListener('dragover', this.handleDragOver, false);
    component.addEventListener('dragenter', this.handleDragEnter, false);
    component.addEventListener('dragleave', this.handleDragLeave, false);
    component.addEventListener('drop', this.handleDrop, false);
    if (this.props.setFunctions) {
      this.props.setFunctions([
        this.pause,
        this.clear,
        this.restart,
        this.removeFile,
        this.performUpload,
        this.clearUploaded,
        this.sendAnalytics,
        this.filesSelected,
        this.totalNumberOfFilesSelected,
        this.restoreFiles,
      ]);
    }
  },
  componentWillUnmount() {
    const component = ReactDOM.findDOMNode(this);
    component.removeEventListener('dragover', this.handleDragOver, false);
    component.removeEventListener('dragenter', this.handleDragEnter, false);
    component.removeEventListener('dragleave', this.handleDragLeave, false);
    component.removeEventListener('drop', this.handleDrop, false);
  },
  sendAnalytics(eventCategory) {
    const eventLabel = UploadAnalytics.eventTypes(
      this.files.map((f) => f.uploadAnalytics),
    );

    const payload = {
      type: WebUI.Analytics.SEND,
      eventCategory: eventCategory,
      eventAction: 'device',
      eventLabel: eventLabel,
      eventValue: this.files.length,
    };

    AnalyticsHandler.handleAnalyticsEvent(payload);
  },

  render() {
    return (
      <div
        id={'image-loader-service-' + this.props.service}
        style={{ height: this.props.height }}
        className={classNames(
          'text-center image-loader-service',
          this.props.service,
          { 'd-none': !this.props.isActive },
        )}
        tabIndex="0">
        <div className="d-flex d-lg-none h-100 flex-column justify-content-center">
          <i className="d-none d-lg-block large fas fa-laptop" />
          <i className="mx-auto d-lg-none large fas fa-mobile-alt" />
          <h3 className="title service-title font-weight-bold">My Phone</h3>
          <small>Upload photos from your phone.</small>
          <div className="mobile-file-upload-btn">
            <UploadButton
              label="Upload"
              ariaLabel="Upload"
              onChange={this.handleFileInputChange}
              fileValidator={this.props.fileValidator}
            />
          </div>
          <CustomText
            textKey="imageLoaderLocalFileImportBannerHtml"
            className="local-file-import-banner local-file-import-banner-mweb d-none"
          />
        </div>
        <div id="fileList" />
        <div
          id="dropArea"
          data-test-id="dropArea" // For testing purposes
          style={{ height: this.props.height }}
          className={classNames(
            'd-md-none d-lg-flex my-auto justify-content-center',
            { 'd-none': this.props.isMobile },
          )}>
          <div className="album-selector-box d-none">
            <div className="image-loader-form-elements">
              {!!this.state.loggedIn && (
                <AlbumSelector
                  targetAlbum={this.props.targetAlbum}
                  onAlbumSelected={this.handleTargetAlbumSelected}
                />
              )}
            </div>
          </div>
          <div
            className={classNames('device', { 'd-none': this.props.isMobile })}>
            <i className="large fas fa-cloud-upload-alt" />
            <h3 className="title font-weight-bold">Drag &amp; Drop Here</h3>
            <small className="d-block">
              {ACCEPTED_FORMATS_NOTE}
            </small>
            <UploadButton
              label="Upload Photos"
              ariaLabel="Upload"
              onChange={this.handleFileInputChange}
              fileValidator={this.props.fileValidator}
            />
          </div>
        </div>
      </div>
    );
  },

  handleTargetAlbumSelected(album) {
    if (this.props.onTargetAlbumSelected)
      this.props.onTargetAlbumSelected(album);
  },

  draggable() {
    return (
      'draggable' in document.createElement('span') && !this.props.isMobile
    );
  },

  handleDragOver(e) {
    e.stopPropagation();
    e.preventDefault();
  },

  dragCounter: 0,
  handleDragEnter(e) {
    e.preventDefault();

    if (this.dragCounter++ === 0) $('#dropArea').addClass('dragover');
  },

  handleDragLeave(e) {
    if (--this.dragCounter === 0) $('#dropArea').removeClass('dragover');
  },

  handleDrop(e) {
    e.preventDefault();

    this.dragCounter = 0;
    $('#dropArea').removeClass('dragover');

    const files = Array.prototype.slice.apply(e.dataTransfer.files);
    this.addFiles(files);
    return false;
  },

  triggerFeatureTracking() {
    sendToGoogleAnalytics('offline-local-import', '');
  },

  handleFileInputChange(e) {
    this.triggerFeatureTracking();
    const $fileInput = e.target;
    const files = Array.from($fileInput.files);

    if (!files.length) return;

    this.addFiles(files);
    $fileInput.value = '';
  },

  async addFiles(files) {
    const filteredFiles = files.filter(
      this.props.fileValidator.isAcceptedFileType,
    );

    if (filteredFiles.length > 0) {
      // Close first: counting PDF pages reads every PDF, which can take a while.
      builderDispatch.dispatch({
        type: PrismUI.CLOSE_ADD_PHOTOS_MODAL,
      });

      const unitCounts = [];
      for (const file of filteredFiles) {
        unitCounts.push(await countUploadUnits(file));
      }
      const totalUploads = unitCounts.reduce((sum, count) => sum + count, 0);

      builderDispatch.dispatch({
        type: WebUI.UPLOAD_BEGUN,
        number_of_files: totalUploads,
      });

      // Every page of every file is counted up front, so the batch ends in
      // exactly one UPLOAD_DONE once each has settled.
      const batchId = usePrismItemStore.getState().beginUploadBatch({
        totalFiles: totalUploads,
        batchId: `upl-${Date.now()}-${Math.round(Math.random() * 1e9)}`,
        sourceFiles: filteredFiles.length,
      });

      for (const [index, uncompressedImageFile] of filteredFiles.entries()) {
        const uploadKeys = Array.from({ length: unitCounts[index] }, () =>
          uuidv4(),
        );
        try {
          if (uncompressedImageFile.type === 'application/pdf') {
            await processPDF(uncompressedImageFile, batchId, uploadKeys);
          } else {
            await processImage(uncompressedImageFile, batchId, uploadKeys[0]);
          }
        } catch (error) {
          dispatchAndDisplayFailedUpload(
            uncompressedImageFile.name,
            batchId,
            uploadKeys,
          );
          console.error('Error processing file:', error);
        }
      }
    }
  },
  _buildFormData() {
    return false;
  },
});

LocalFileImportIndexedDB.defaultProps = {
  fileValidator: new ImageUploadFileValidator(),
};

const processFileAndUpload = async (
  uncompressedImageFile,
  processedFile,
  batchId,
  uploadKey,
) => {
  const compressedImageForThumbnails = await compressImage(
    processedFile || uncompressedImageFile,
    { maxWidthOrHeight: 512 },
  );

  const fileToUpload = processedFile || uncompressedImageFile;

  // Uploaded as-is (only the thumbnail is compressed). A PDF page arrives with
  // the whole PDF as its original, so only image files report a picked size.
  sessionTracker.trackUploadedImage({
    sentBytes: fileToUpload.size,
    pickedBytes:
      uncompressedImageFile.type === 'application/pdf'
        ? undefined
        : uncompressedImageFile.size,
  });

  const fileData = {
    file: fileToUpload,
    compressedImage: compressedImageForThumbnails,
    status: 'pending',
    uploadUrl: uploadUrl(),
    prismItemID: prismItem.num,
    prismItemIDs: [],
    createdAt: new Date(),
    // Persisted so the upload settles in its batch once it finishes.
    batchId,
    uploadKey,
  };

  db.imageUpload
    .add(fileData)
    .then(() => console.log(`${fileData.file?.name} uploaded successfully`))
    .catch((e) => {
      // Never saved, so never uploaded: settle it or the batch hangs.
      dispatchAndDisplayFailedUpload(fileData.file?.name, batchId, [uploadKey]);
      return handleDexieError(e, { from: 'processFileAndUpload' });
    });
  return fileData;
};

const loadPdf = async (file) => {
  pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;
  const pdfData = await readFileAsArrayBuffer(file);
  return pdfjsLib.getDocument({ data: pdfData }).promise;
};

// How many images a file uploads as: a PDF's page count, else 1. The PDF is
// released straight away; processPDF reloads it, so only one is held at a time.
// A PDF that can't be read counts as 1 and then fails as one file.
const countUploadUnits = async (file) => {
  if (file.type !== 'application/pdf') return 1;

  let pdfDoc;
  try {
    pdfDoc = await loadPdf(file);
    return pdfDoc.numPages;
  } catch (error) {
    console.error('Failed to read PDF page count', file.name, error);
    return 1;
  } finally {
    pdfDoc?.destroy();
  }
};

const processPDF = async (uncompressedImageFile, batchId, uploadKeys) => {
  let pagesSubmitted = 0;
  let pdfDoc;

  try {
    pdfDoc = await loadPdf(uncompressedImageFile);
    const numPages = pdfDoc.numPages;
    // The batch was sized from the count; a PDF that couldn't be counted fails whole.
    if (numPages !== uploadKeys.length) {
      throw new Error('PDF page count does not match the batch');
    }

    sendToGoogleAnalytics('pdf-upload', numPages);

    const canvasPDF = document.createElement('canvas');
    canvasPDF.style.display = 'none';
    document.body.appendChild(canvasPDF);
    const ctx = canvasPDF.getContext('2d');

    for (let pageNum = 1; pageNum <= numPages; pageNum++) {
      const page = await pdfDoc.getPage(pageNum);
      const viewport = page.getViewport({ scale: 2 });

      canvasPDF.width = viewport.width;
      canvasPDF.height = viewport.height;

      await page.render({
        canvasContext: ctx,
        viewport: viewport,
        background: 'rgba(0,0,0,0)',
      }).promise;

      const blob = await new Promise((resolve) =>
        canvasPDF.toBlob(resolve, 'image/png'),
      );
      const fileName = `${uncompressedImageFile.name}-${pageNum}.png`;
      const newFile = new File([blob], fileName, { type: 'image/png' });

      await processFileAndUpload(
        uncompressedImageFile,
        newFile,
        batchId,
        uploadKeys[pageNum - 1],
      );
      pagesSubmitted = pageNum;
    }
    document.body.removeChild(canvasPDF);
  } catch (error) {
    // Submitted pages settle when they upload; the rest never will.
    dispatchAndDisplayFailedUpload(
      uncompressedImageFile.name,
      batchId,
      uploadKeys.slice(pagesSubmitted),
    );
    console.error('Error processing PDF:', error);
  } finally {
    pdfDoc?.destroy();
  }
};

const dispatchAndDisplayFailedUpload = (fileName, batchId, uploadKeys = []) => {
  builderDispatch.dispatch({
    type: WebUI.UPLOAD_PROGRESS,
  });

  uploadKeys.forEach((key) =>
    usePrismItemStore.getState().markUploadSettled({ batchId, key }),
  );

  usePrismItemStore.setState(({ failedImagesUploaded }) => ({
    failedImagesUploaded: [...failedImagesUploaded, fileName],
  }));
};

const processImage = async (uncompressedImageFile, batchId, uploadKey) => {
  const convertedFile = await convertHEICIfNeeded(uncompressedImageFile);
  await processFileAndUpload(
    uncompressedImageFile,
    convertedFile,
    batchId,
    uploadKey,
  );
};

export default LocalFileImportIndexedDB;
